import React,{ useState, useEffect, useCallback } from 'react'
import CollapsablePanel from '../common/collapsable-panel/collapsable-panel';
import { useLazyQuery } from '@apollo/client';
import { GET_ROOT_ORGS } from '../../graphql/org-gql';
import { ICategory, IOrg } from '../../types/org';
import { Input, Label, Table } from 'reactstrap';
import { MoveIcon } from '../common/icons';
import { CategoryType } from '../../types/constants';
import SpinnerOverlay from '../common/spinner/spinner';
import useAuth from '../../hook/useAuth';
import TopOrgMoveModal from './top-org-move';
import useCheckGroup from '../../hook/useCheckGroup';
import Button from '../common/button';

type CategoryDetailProps = {
    category: ICategory;
}

const CategoryDetail = (props: CategoryDetailProps) => {
    const { category } = props
    const {isFrenchTranslator,isAdmin } = useAuth();
    const [orgMoveOpen, setOrgMoveOpen] = useState<boolean>(false);
    const toggleOrgMove = useCallback(() => {setOrgMoveOpen(!orgMoveOpen)}, [orgMoveOpen])
    const {checkGroup} = useCheckGroup<number>();
    const [getRootOrgs, { loading, data }] = useLazyQuery(GET_ROOT_ORGS,
        {
            notifyOnNetworkStatusChange: true,
            onCompleted: (data) => {
                //console.log("data:",data)
                checkGroup.init(data?.rootOrgs.map((e:IOrg) => e.id))
            }
        });

    const movable = category?.type === CategoryType.ORGANIZATION
    const showCheckBox = category?.type === CategoryType.ORGANIZATION && !isFrenchTranslator


    useEffect(() => {
        if (category) {
            getRootOrgs({ variables: { categoryId: category.id  } });
            }
      }, [category]);

    return (<div>
            {<TopOrgMoveModal category={category} isOpen={orgMoveOpen} toggle={toggleOrgMove} topOrgIds={checkGroup.getCheckedValues()}></TopOrgMoveModal>}
            {<CollapsablePanel headTitle="Children Organizations" initCollapse={false} helpUrl="">
                {loading && <SpinnerOverlay />}
                {data?.rootOrgs?.length === 0 && <div>No organization found.</div>}
                {(data?.rootOrgs) &&
                    (<> {movable && !isFrenchTranslator &&
                        <Button color="primary" style={{ marginBottom: '15px' }} disabled={!isAdmin || checkGroup.isNoneChecked()} onClick={toggleOrgMove}>
                            <MoveIcon />
                            &nbsp;Move
                        </Button>
                    }
                    <Table striped className="organizations-table fixed" id="child_organizations">
                        <thead>
                            <tr>
                                {showCheckBox && <th className="icon-column">
                                    <Input 
                                        id="selectAllCheckbox" 
                                        aria-label="Select All" 
                                        className="form-check-input" 
                                        type='checkbox' 
                                        onChange={checkGroup.onCheckAll} 
                                        checked={checkGroup.isAllChecked()} />      
                                </th>}
                                <th>Organization</th>
                                <th className="date-column date-column-mmm-dd-yyyy">Start Date</th>
                            </tr>
                        </thead>
                        <tbody>{data?.rootOrgs?.map((rootOrg: IOrg, index: number) => (
                            <tr key={index}>
                                {showCheckBox && <td>
                                    <Input
                                        className="form-check-input"
                                        type="checkbox"
                                        value={index}
                                        id={`checkboxNoLabel-${index}`}
                                        checked={checkGroup.isChecked(rootOrg.id)}
                                        onChange={event=>checkGroup.onCheck(event, rootOrg.id)}
                                        aria-label={`select ${rootOrg?.orgName}`}
                                    />
                                </td>}
                                <td>{rootOrg.orgName}</td>
                                <td>{rootOrg.createDate}</td>
                            </tr>))}
                        </tbody>
                    </Table>
                    </> )
                    }
                </CollapsablePanel>
            }
        </div>)
}

export default CategoryDetail
